import './login.css';
import { useState } from 'react';
import logo from '../assets/images/dashboard/lepton-logo.png';

const Login = ({ onLoginSuccess }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [emailInvalid, setEmailInvalid] = useState(false);
    const [passwordEmpty, setPasswordEmpty] = useState(false);
    const [emailTouched, setEmailTouched] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [authError, setAuthError] = useState(false); // Estado para error de autenticación

    const setCookie = (name, value, days) => {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/; secure=true;";
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const isEmailValid = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        setAuthError(false);
    };

    const handleEmailBlur = () => {
        setEmailTouched(true);
        setEmailInvalid(!isEmailValid(email));
    };

    const handlePasswordBlur = () => {
        setPasswordEmpty(password === '');
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
        setAuthError(false);
    };

    const handleLogin = async (e) => {
        e.preventDefault();

        if (!isFormValid) return;

        setIsLoading(true); 
        setErrorMessage('');

        try {
            const response = await fetch('https://pro.lepton-seguridad.com/api-v2/user/auth', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json, text/plain, */*'
                },
                body: JSON.stringify({
                    login: email,
                    password: password
                }),
            });

            if (response.ok) {
                const data = await response.json();
                setCookie('session_key', data.hash, 1);
                // console.log('Login exitoso', data);
                onLoginSuccess(data.hash);
            } else {
                setAuthError(true); 
                setPassword('');
                setErrorMessage('Nombre de usuario o contraseña incorrectos.');
            }
        } catch (error) {
            setErrorMessage('Error al conectar con el servidor.');
        } finally {
            setIsLoading(false);
        }
    };

    const isFormValid = email !== '' && password !== '' && isEmailValid(email);
    

    return (
        <div className="login_container">
            {isLoading && (
                <div className="loading_overlay">
                    {/* <span className="material-symbols-outlined loading_icon">progress_activity</span> */}
                    <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
                </div>
            )}
            <div className={`login_panel ${isLoading ? 'loading_blur' : ''}`}>
                <img src={logo} className="login_logo" alt="Logo" />
                <p>No se encontró una clave de acceso válida. Asegúrese de acceder desde la página principal de Leptón e intente nuevamente.</p>
                <form className="login_form" onSubmit={handleLogin}>
                    <h2>Iniciar Sesión</h2>

                    <label className={`form_label ${(emailInvalid && emailTouched) || authError ? 'error' : ''}`}>Correo electrónico</label>
                    <div className={`input_container ${(emailInvalid && emailTouched) || authError ? 'error' : ''}`}>
                        <span className={`material-symbols-outlined input_icon ${(emailInvalid && emailTouched) || authError ? 'error' : ''}`}>person</span>
                        <input
                            type="email"
                            placeholder="Introduce tu correo"
                            value={email}
                            onChange={handleEmailChange}
                            onBlur={handleEmailBlur}
                            required
                        />
                    </div>
                    {emailInvalid && emailTouched && (
                        <small className="error_message">Correo electrónico debe ser válido</small>
                    )}

                    <label className={`form_label ${passwordEmpty || authError ? 'error' : ''}`}>Contraseña</label>
                    <div className={`input_container ${passwordEmpty || authError ? 'error' : ''}`}>
                        <span className={`material-symbols-outlined input_icon ${passwordEmpty || authError ? 'error' : ''}`}>lock</span>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Introduce tu contraseña"
                            value={password}
                            onChange={handlePasswordChange}
                            onBlur={handlePasswordBlur}
                            required
                        />
                        <button
                            type="button"
                            className="toggle_password"
                            onClick={togglePasswordVisibility}
                        >
                            <span className='material-symbols-outlined'>{showPassword ? 'visibility' : 'visibility_off'}</span>
                        </button>
                    </div>
                    {passwordEmpty && (
                        <small className="error_message">Campo obligatorio</small>
                    )}

                    {errorMessage && <small className="error_message">{errorMessage}</small>}

                    <button type="submit" disabled={!isFormValid || isLoading}>
                        Iniciar sesión
                    </button>

                </form>
            </div>
        </div>
    );
};

export default Login;

